exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".specialist-export-container[data-v-e492f8da] {\n  padding: 25px;\n  max-width: 600px;\n  margin: auto;\n}\n", ""]);

// exports
